import Model from "@/lib/model/model";

export class DimensionConfig extends Model {
  dimensionKey = "";
  scoreType = 1;
  score = 0;
}

export class DimensionGroup extends Model {
  groupName = "";
  showChart = 0;
  showEvaluate = 0;
  readingGuidelinesType = 0;
  readingGuidelinesMessage = "";
  iconUrl = "https://cdn.hina.com/pdf/dimension-basic-qualities.svg";
  iconH5Url = "https://cdn.hina.com/pdf/dimension-basic-qualities-white.svg";
  dimensionKeyList: string[] = [""];
  scoreLimit: number[] = [0];
  levelDesc: string[] = [""];
  sort = 0;
  configType = 0; // 配置方式 0:标准参照 1:常模参照
  compareType = 0; // 对照方式 0:标准参照-分数等级对照 1:常模参照-百分位等级对照
  normScoreType = 0; // 常模划档方式 0:标准参照-无含义 1:常模参照-实际常模 2:常模参照-理论常模

  static getDefaultDimensionGroup(dimensionConfigList: DimensionConfig[]) {
    return new DimensionGroup().assign({
      groupName: "岗位素质",
      dimensionKeyList: dimensionConfigList.map(item => item.dimensionKey),
      showChart: 2,
      showEvaluate: 1,
      scoreLimit: [30, 70],
      levelDesc: ["欠佳", "中等", "优秀"]
    });
  }
}

export class Dimension extends Model {
  dimensionConfigList: DimensionConfig[] = [];
  dimensionGroupList: DimensionGroup[] = [];

  public objectArrayClasses() {
    return {
      dimensionConfigList: DimensionConfig,
      dimensionGroupList: DimensionGroup
    };
  }
}
